// Shared domain types. Mirrors the shapes the Tornado backend sends back
// from /api/v1/* and over the WebSocket. The legacy frontend treats
// everything as untyped `any` (see js/main.js, js/cart.js), so these types
// are derived from observed payloads rather than an authoritative schema.

export interface UserData {
  initialized: boolean;
  impersonation?: { actor_id: number; session_id: string; expires_at: number } | null;
  id?: number;
  username: string;
  email?: string;
  picture?: string;
  roles?: string[];
  tos?: string | null;
  stripe_session_id?: string | null;
}

export const GUEST: UserData = {
  initialized: false,
  username: "guest",
  id: -1,
};

export interface RegionProperties {
  price?: number | Partial<Record<"CHF" | "EUR" | "USD", number>>;
  name?: string;
  [k: string]: unknown;
}

export interface Region {
  id?: string;
  name?: string;
  int_name?: string;
  flag?: string;
  properties?: RegionProperties;
  original_geojson?: string;
}

export interface PixelInfo {
  lat: number;
  lng: number;
}

/** Cart-only extras (persisted in IndexedDB); matches legacy `pixel.customer`. */
export interface CartCustomer {
  frameName?: string;
  artistName?: string;
  frameColor?: string;
  imageData?: string;
  imageName?: string;
  imageType?: string;
}

export interface Pixel {
  pixel: number;
  location?: string;
  image?: string;
  frameName?: string;
  artistName?: string;
  country?: string;
  region?: Region;
  info: PixelInfo;
  customer?: CartCustomer;
}

export type CartMap = Record<string, Pixel>;

export type WebSocketTag =
  | "connected"
  | "reserve"
  | "unreserve"
  | "logout"
  | "ping"
  | "pong"
  | "user_count"
  | "login"
  | "logout"
  | "region"
  | "pixel"
  | "cart_expired"
  | string;

export interface WSMessage<T = unknown> {
  tag: WebSocketTag;
  content: T;
  id?: string;
}
